import { Layout, Menu } from "antd";
import {
  HomeOutlined,
  EnvironmentOutlined,
  DownloadOutlined,
  AppstoreOutlined,
  InfoCircleOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { HelpOutlineOutlined } from "@mui/icons-material";
const { Sider } = Layout;

function MySidebar({ collapsed, idx }) {
  return (
    <Sider trigger={null} collapsible collapsed={collapsed}>
      <div className="demo-logo-vertical"></div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[idx]}
        //defaultSelectedKeys={[key]}
        items={[
          {
            key: "0",
            icon: <HomeOutlined />,
            label: <Link to="/">Beranda</Link>,
          },

          {
            key: "1",
            icon: <AppstoreOutlined />,
            label: <Link to="/webmap">Webmap</Link>,
          },
          {
            key: "2",
            icon: <DownloadOutlined />,
            label: <Link to="/unduh">Unduh Data</Link>,
          },
          {
            key: "3",
            icon: <EnvironmentOutlined />,
            label: (
              <Link target="_blank" to="https://tanahair.indonesia.go.id/map">
                Penyaji Peta
              </Link>
            ),
          },
          {
            key: "4",
            icon: <ApartmentOutlined />,
            label: <Link to="/tools">Tools</Link>,
          },
          {
            key: "5",
            icon: <InfoCircleOutlined />,
            label: <Link to="/kontak">Kontak Kami</Link>,
          },
          {
            key: "6",
            icon: <HelpOutlineOutlined />,
            label: <Link to="/bantuan">Bantuan</Link>,
          },
        ]}
      />
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <a
          href="https://clustrmaps.com/site/nq1r"
          title="Visit tracker"
          target="_blank"
        >
          <img
            width="75px"
            src="//www.clustrmaps.com/map_v2.png?d=QNnjyPVEqyCy1nS9wDeAb5kzocSFWhIm9vyZTF0Nhpg"
          />
        </a>
      </div>
    </Sider>
  );
}
export default MySidebar;
